module.exports = __webpack_public_path__ + "static/assets/74a059c43e52a614bb6d873cd3a817b5.gif";